import {useEffect, useState} from 'react'
import DealerCard from './DealerCard'
import useSearch from '../../hooks/useSearch'
import findClosestMarkers from '../../utils/findClosestMarkers'
import shuffleArray from '../../utils/shuffleArray'
import useSearchStore from '../../stores/useSearchStore'
import useCountryStore from '../../stores/useCountryStore'

const DealersLoop = ({dealers, importers, noCountryText, noDealersText}) => {
    const {searchString} = useSearchStore()
    const {selectedCountry} = useCountryStore()
    const {location} = useSearch(selectedCountry, searchString)
    const [foundLocation, setFoundLocation] = useState(null)

    if (!dealers && !importers) return

    const allMarkers = [...dealers, ...importers]

    useEffect(() => {
        if (location && searchString.length > 2) {
            const closestMarkers = findClosestMarkers(allMarkers, location)
            const closestMarkersSorted = closestMarkers.sort((a, b) => a.distance - b.distance)
            setFoundLocation(closestMarkersSorted)
        }
    }, [location])

    useEffect(() => {
        if (searchString.length <= 2) {
            const allMarkersShuffled = shuffleArray(allMarkers)
            setFoundLocation(allMarkersShuffled)
        }
    }, [searchString, selectedCountry])

    if (selectedCountry === '') return <div>{noCountryText}</div>

    return (
        foundLocation && foundLocation.map(dealer =>
            <DealerCard
                key={dealer.name.replace(/\s+/g, '_').toLowerCase()}
                name={dealer.name}
                website={dealer.website}
                city={dealer.city}
                zipCode={dealer.zip_code}
                address={dealer.address}
                country={dealer.country_code}
            />
        )
    )
}

export default DealersLoop
